import { render, staticRenderFns } from "./BulkTagAnnotate.vue?vue&type=template&id=0a5a25e2&scoped=true"
import script from "./BulkTagAnnotate.vue?vue&type=script&lang=js"
export * from "./BulkTagAnnotate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a25e2",
  null
  
)

export default component.exports